import { BackendAdapterCube, ICubeResponse } from "@spawn/backend-adapter-cube";
import { consumer, inject } from "@spawn/core";
import { FreegameSpinActionCube } from "@spawn/freegames";
import { parseNudgeNetworkState } from "@spawn/nudge";
import { parseRevealNetworkState } from "@spawn/reveal";
import { SymbolService } from "../../services/symbolService";
import { UncoverTierService } from "../../services/uncoverTierService";
import { invertNudgingOffsets, mapCalaverasToGoldenBonus } from "../hacks";
import { IGameNetworkState } from "../networkState";
import { INrgCubeGameResult } from "../types/cube";
import { mockSpinResponses } from "./mockSpinResponses";

@consumer
export class ExtendedSpinActionCube extends FreegameSpinActionCube {
	@inject protected readonly symbolService!: SymbolService;
	@inject protected readonly uncoverTierService!: UncoverTierService;

	// TEMPORARY TEST HIJACK: no request is sent, the canned responses are replayed in a loop.
	// TODO: remove this when code is accepted
	private static mockIndex = 0;

	public override async execute(): Promise<IGameNetworkState> {
		const searchParams = new URLSearchParams(window.location.search);
		const useHardcodedSequence = searchParams.get("test-sequence");
		if(!useHardcodedSequence) {
			return super.execute()
		}

		const payload = mockSpinResponses[ExtendedSpinActionCube.mockIndex] as INrgCubeGameResult;
		ExtendedSpinActionCube.mockIndex = (ExtendedSpinActionCube.mockIndex + 1) % mockSpinResponses.length;

		// fake network latency
		await new Promise((resolve) => setTimeout(resolve, 100));

		return this.parse({ response: payload }, this.adapter);
	}

	public override parse(response: ICubeResponse<INrgCubeGameResult>, adapter: BackendAdapterCube): IGameNetworkState {
		const transition = response.response.transition;

		const result = super.parse(response, adapter) as IGameNetworkState;
		this.symbolService.replaceSwingingMysteriesIfNotNeeded(result.slotGameBase.reels);
		const uncoverTier = this.uncoverTierService.fromWinFactor(result.slotGameBase.winFactor);

		const feature = {
			reveal: mapCalaverasToGoldenBonus(parseRevealNetworkState(transition.slotGame.nudgeAndReveal, uncoverTier)),
			nudging: invertNudgingOffsets(parseNudgeNetworkState(transition.slotGame.nudgeAndReveal)),
		};

		return {
			...result,
			...feature,
		};
	}
}
